import HighLightBusiness from './HighLightBusiness.jsx';

export {
  HighLightBusiness
}


// WEBPACK FOOTER //
// ./components/fair/sub-view/business/index.js